<template>
	<main class="basic-setting-list" style="background: #f5f5fb">
		<div class="mainList">
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px">
				<el-form-item>
					<InputTopTip placeholder="系统名称" v-model="filterQuery.title">
						<el-input style="width: 150px" placeholder="" v-model="filterQuery.title" size="small" @keyup.native.enter="(currentPage = 1), queryPageListData()"> </el-input>
					</InputTopTip>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px"
						@click=";(currentPage = 1), queryPageListData()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>
		<div>
			<section class="list-area">
				<div
					class="list-area-otis"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
					"
				>
					<template>
						<div style="display: flex; padding-left: 18px">
							<el-button
								type="primary"
								size="small"
								icon="el-icon-plus"
								style="margin-right: 15px"
								@click="openCreate"
								>新建</el-button
							>
						</div>
						<div>
							<el-button
								type="primary"
								size="small"
								icon="el-icon-delete"
								:class="multipleSelection.length === 0 ? 'box' : 'box2'"
								:disabled="multipleSelection.length === 0"
								@click="batchDelete"
								v-if="multipleSelection.length > 0"
								>批量删除</el-button
							>
						</div>
					</template>
				</div>
				<el-table
					:data="listControl.data"
					row-class-name="row"
					tooltip-effect="dark"
					@selection-change="val => (this.multipleSelection = val)"
					:header-cell-style="{ background: '#FAFAFA', color: '#000000', height: '10px !important' }"
				>
					<el-table-column type="selection" width="60" align="center" v-if="$permissions([SP31003, SP31004, SP31005])">
					</el-table-column>
					<el-table-column align="left" label="层级">
						<template slot-scope="scope">
							{{ admin_levels.find(v => v.id == scope.row.admin_level)?.title }}
						</template>
					</el-table-column>
					<el-table-column label="所属辖区" :formatter="district_name"></el-table-column>
					<el-table-column label="数据范围" :formatter="data_scope"></el-table-column>
					<el-table-column align="left" label="LOGO" prop="logo">
						<template slot-scope="scope">
							<img :src="scope.row.logo" style="width: 30px; height: 30px" />
						</template>
					</el-table-column>
					<el-table-column align="left" label="系统名称" prop="title" />
					<el-table-column align="left" label="二级域名" prop="domain" />
					<el-table-column align="left" label="关联应用">
						<template slot-scope="scope">
							{{ scope.row.application.map(v => apps.find(a => a.id == v)?.name).join(',') }}
						</template>
					</el-table-column>
					<el-table-column align="left" label="失效时间" prop="expired_at" />
					<template
						v-if="
							$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value
						"
					>
						<el-table-column align="center" label="操作" class-name="opscol" width="160">
							<template v-slot:default="slot">
								<div class="table-mgn2">
									<div style="color: #3f6af7;" @click="openUpdate(slot.row)">
										<el-tooltip content="编辑" placement="bottom" effect="light">
											<svg class="icon" aria-hidden="true">
												<use xlink:href="#icon-iconoutlinesetting"></use>
											</svg>
										</el-tooltip>
									</div>

									<div
										class="icon delete"
										style="color: #f13048"
										@click="promptRemove(slot.row.id)"
									>
										<el-tooltip content="删除" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none"
											>
												<use xlink:href="#icon-deltred"></use>
											</svg>
										</el-tooltip>
									</div>

									<!-- <div
										v-if="slot.row.state === 0"
										class="icon delete"
										style="color: #f13048"
										@click="resetState(slot.row.id, 1)"
										v-permission="SP32008"
									>
										<el-tooltip content="禁用" placement="bottom" effect="light">
											<svg
												class="icon"
												aria-hidden="true"
												style="width: 100%; height: 100%; outline: none; box-shadow: none"
											>
												<use xlink:href="#icon-prohibit"></use>
											</svg>
										</el-tooltip>
									</div>
									<div
										v-else
										class="icon delete"
										style="color: #4ab96d"
										@click="resetState(slot.row.id, 0)"
										v-permission="SP32008"
									>
										<el-tooltip content="恢复" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-circle-check"></i>
										</el-tooltip>
									</div> -->

									<div style="color: #666666" @click="download(slot.row)" v-permission="SP31008">
										<el-tooltip content="下载" placement="bottom" effect="light">
											<i aria-hidden="true" class="icon el-icon-download"></i>
										</el-tooltip>
									</div>
								</div>
							</template>
						</el-table-column>
					</template>
				</el-table>
				<div class="pagination-page">
					<span class="pagetotal">
						总计：{{ listControl.total }}条/{{ Math.ceil(listControl.total / listControl.pageSize) }}页
					</span>
					<el-pagination
						class="pagination"
						background
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-size="listControl.pageSize"
						:total="listControl.total"
						:current-page.sync="listControl.currentPage"
						:page-sizes="[5, 10, 15, 20, 30]"
						layout="prev,pager,next,jumper,sizes"
						style="margin-top: 21px; margin-left: 10px"
					>
					</el-pagination>
				</div>
			</section>
		</div>

		<!-- 新建dialog -->
		<el-dialog
			class="practice-sheet-new-edit-dialog"
			width="500px"
			:close-on-click-modal="false"
			:visible.sync="dialogControl.visible"
			top="5vh"
		>
			<div class="dialog-title2" slot="title">
				<span>{{ dialogControl.title }}</span>
				<el-divider></el-divider>
			</div>
			<template>
				<el-form :model="dialogForm" ref="newForm" :rules="dialogFormRules">
					<el-form-item prop="admin_level">
            <InputTopTip v-model="dialogForm.admin_level" placeholder="层级">
              <el-select @change="changeAdminLevel" v-model="dialogForm.admin_level" size="small" style="width: 100%;" placeholder="">
                <el-option
                  v-for="item in admin_levels"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="region_code" _m="!t-20px">
            <InputTopTip v-model="dialogForm.region_code" placeholder="辖区">
              <el-cascader
                :disabled="!!!dialogForm.admin_level"
                style="width: 100%"
                ref="cascaderArrObj"
                placeholder=""
                v-model="dialogForm.region_code"
                size="small"
                :options="addressLevelOptions"
                :props="{
                  value: 'id',
                  label: 'name',
                  children: 'child',
                  expandTrigger: 'click',
                  emitPath: false
                }"
              >
              </el-cascader>
            </InputTopTip>
          </el-form-item>
          <el-form-item prop="data_scope" _m="!t-20px">
            <InputTopTip v-model="dialogForm.data_scope" placeholder="数据范围">
              <el-select v-model="dialogForm.data_scope" size="small" style="width: 100%;" placeholder="">
                <el-option
                  v-for="item in scopeAll"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val"
                ></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>
					<el-form-item prop="application"  _m="!t-20px">
						<InputTopTip placeholder="关联应用" v-model="dialogForm.application">
							<el-select
								multiple
								placeholder=""
								v-model="dialogForm.application"
								style="width: 100%"
								size="small"
							>
								<el-option v-for="item in apps" :key="item.id" :label="item.name" :value="item.id" />
							</el-select>
						</InputTopTip>
					</el-form-item>
					<el-form-item prop="title"  _m="!t-20px">
						<InputTopTip placeholder="系统名称" v-model="dialogForm.title">
							<el-input placeholder="" v-model="dialogForm.title" style="width: 100%" size="small" />
						</InputTopTip>
					</el-form-item>
					<el-form-item prop="logo"  _m="!t-20px">
						<div style="width: 100%">
							<div style="font-size: 16px; color: #323232" _text="bolder">logo</div>
							<div class="avatar-uploader">
								<img v-if="dialogForm.logo" :src="dialogForm.logo" class="avatar" @click="uploadImg"/>
								<i v-else class="el-icon-plus avatar-uploader-icon" @click="uploadImg"></i>
							</div>
						</div>
						<div style="font-size: 12px; color: #717171">JPG/PNG/SVG/BMP格式，2MB以内</div>
					</el-form-item>
					<el-form-item prop="download_url"  _m="!t-15px">
						<InputTopTip placeholder="地址链接" v-model="dialogForm.download_url">
							<el-input placeholder="" v-model="dialogForm.download_url" style="width: 100%" size="small" />
						</InputTopTip>
					</el-form-item>
					<el-form-item prop="domain"  _m="!t-20px">
						<InputTopTip placeholder="二级域名" v-model="dialogForm.domain">
							<el-input placeholder="" v-model="dialogForm.domain" style="width: 100%" size="small" />
						</InputTopTip>
					</el-form-item>
					<el-form-item prop="expired_at"  _m="!t-20px">
						<el-date-picker v-model="dialogForm.expired_at" type="date" placeholder="失效时间" style="width: 100%">
						</el-date-picker>
					</el-form-item>
					<div style="margin-top: 25px"><el-divider /></div>
					<el-form-item
						style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center"
					>
						<el-button
							class="btn-close"
							@click="dialogControl.visible = false"
							style="width: 80px; height: 32px; line-height: 1px"
							>取 消</el-button
						>
						<el-button
							class="btn-prim"
							type="primary"
							@click="confirm"
							style="width: 80px; height: 32px; line-height: 1px"
						>
							{{ dialogControl.action == 'create' ? '保存' : '更新' }}
						</el-button>
					</el-form-item>
				</el-form>
			</template>
		</el-dialog>

		<!-- 批量创建 -->
		<batch-import-account ref="importDialog" :target="'school_admin'" />
	</main>
</template>
<script>
import {
	SP31001,
	SP31002,
	SP31003,
	SP31004,
	SP31005,
	SP31006,
	SP31007,
	SP31008,
	SP32008
} from '@/utils/permissionMap.js'
import { debounce, last } from 'lodash'
import BatchImportAccount from '@/components/BatchImportAccount'
import { uploadFileEvent, httpRequest } from '../ResourceManagement/UploadEvent'

export default {
	props: [],
	components: { BatchImportAccount },
	data() {
		return {
			SP31001,
			SP31002,
			SP31003,
			SP31004,
			SP31005,
			SP31006,
			SP31007,
			SP31008,
			SP32008,

			// 代理级别
			admin_levels: [
				{ id: 1, title: '省代' },
				{ id: 2, title: '市代' },
				{ id: 3, title: '区代' }
			],
			apps: [{ id: 'mppt', name: '授课系统' }], // 应用列表
			addressLevelOptions: [],
			addressOptions: [],
			scopeAll: [
        { name: '全部', val: 1 },
        { name: '同级', val: 2 },
        { name: '同级及子级', val: 3 }
      ],

			multipleSelection: [], // 多选

			agencys: [], // 代理商列表

			// 列表查询条件
			filterQuery: {
				title: ''
			},

			// 列表控制器
			listControl: {
				pageSize: 10,
				currentPage: 1,
				total: 0,
				data: []
			},

			// dialog 控制器
			dialogControl: {
				action: 'create', // create,update 新增和修改
				visible: false, // dialog 显示隐藏
				title: '', // dialog 标题
				confirmLabel: '', // dialog 确定标题
				submitting: false, // 提交加载状态
				uploading: false // 图片正在上传
			},

			// dialog form 表单
			dialogForm: {
				admin_level: '',
				region_code: '',
				data_scope: '',
				application: [],
				title: '',
				logo: '',
				download_url: '',
				domain: '',
				expired_at: ''
			},

			// dialog form 校验规则
			dialogFormRules: {
        admin_level: [{ required: true, message: '请选择层级', trigger: ['blur', 'change'] }],
				region_code: [{ required: true, message: '请选择辖区', trigger: ['blur', 'change'] }],
        data_scope: [{ required: true, message: '请选择数据范围', trigger: ['blur', 'change'] }],
				title: [
					{
						required: true,
						message: '请输入真实姓名',
						trigger: ['blur', 'change']
					}
				],
				logo: [
					{
						required: true,
						message: '未上传logo',
						trigger: ['blur', 'change']
					}
				],
				domain: [
					{
						required: true,
						message: '未输入二级域名',
						trigger: ['blur', 'change']
					}
				],
				download_url: [
					{
						required: true,
						message: '未输入下载地址',
						trigger: ['blur', 'change']
					}
				],
				application: [
					{
						required: true,
						message: '未选择关联应用',
						trigger: ['blur', 'change']
					}
				],
				expired_at: [
					{
						required: true,
						message: '未选择过期时间',
						trigger: ['blur', 'change']
					}
				]
			}
		}
	},
	created() {
		this.RegionalLevel()
		// this.queryAgencys()
		this.queryPageListData()
	},
	methods: {
		admin_level(row) {
      try {
        return this.admin_levels.find(item => item.id == row?.admin_level)?.title
      } catch(_) {
        return ''
      }
    },
    data_scope(row) {
      try {
        return this.scopeAll.find(item => item.val == row?.data_scope)?.name
      } catch(_) {
        return ''
      }
    },
    district_name(row) {
      try {
        if (row.admin_level == 1) {
          return `${row.district.l1_name}`
        } else if (row.admin_level == 2) {
          return `${row.district.l1_name}/${row.district.l2_name}`
        } else if (row.admin_level == 3) {
          return `${row.district.l1_name}/${row.district.l2_name}/${row.district.l3_name}`
        }
      } catch(_) {
        return ''
      }
    },
    removeEmptyItems(arr, name = 'child') {
			const newArr = []
			for (let i = 0; i < arr.length; i++) {
				const item = arr[i]
				if (item[name]?.length >= 1) {
					item[name] = this.removeEmptyItems(item[name])
				} else {
					item[name] = undefined
				}
				newArr.push(item)
			}
			return newArr
		},
    async RegionalLevel() {
			const res = await this.$api.school.ssxlist(0)
      this.addressOptions = this.removeEmptyItems(res)
		},
    changeAdminLevel(level) {
      this.addressLevelOptions = this.recursiveChange(this.addressOptions, level)
      this.dialogForm.region_code = ''
    },
    recursiveChange(items, level) {
      return items.map(item => ({
        ...item,
        child: level > 1 ? this.recursiveChange(item.child || [], level - 1) : undefined
      }))
    },
		// 获取代理商家数据
		async queryAgencys() {
			let res = await this.$api.agency.list({
				page: 1,
				page_size: 50
			})

			this.agencys = res.data
		},

		// 获取页面列表数据
		async queryPageListData(type) {
			let query = { ...this.filterQuery }
			if (type == 'refresh') query = {}

			this.dialogControl.submitting = false
			let res = await this.$api.agency_system.list({
				page: this.listControl.currentPage,
				page_size: this.listControl.pageSize,
				...query
			})
			this.listControl.total = res.meta.total
			this.listControl.pageSize = parseInt(res.meta.per_page)
			this.listControl.data = res.data
		},

		// 创建打开dialog
		openCreate() {
			this.dialogControl.uploading = false
			this.dialogControl.title = '新增基础设置'
			this.dialogControl.action = 'create'

      this.dialogForm.admin_level = ''
      this.dialogForm.region_code = ''
      this.dialogForm.data_scope = ''

			this.dialogForm.title = ''
			this.dialogForm.application = ''
			this.dialogForm.domain = ''
			this.dialogForm.download_url = ''
			this.dialogForm.expired_at = ''
			this.dialogForm.logo = ''

			this.dialogControl.visible = true
			this.dialogForm.name = ''
		},

		// 修改打开dialog
		async openUpdate(data) {
			this.dialogControl.uploading = false
			this.dialogControl.title = `修改${data.title}`
			this.dialogControl.action = 'update'
			const { district, admin_level, data_scope } = data
			this.changeAdminLevel(admin_level)
			const { l1_id, l2_id, l3_id } = district
			this.dialogForm.region_code = admin_level == 1 ? [l1_id] : admin_level == 2 ? [l1_id, l2_id] : [l1_id, l2_id, l3_id]
			this.dialogForm.data_scope = data_scope
			this.dialogForm.admin_level = admin_level
			this.dialogForm.title = data.title
			this.dialogForm.application = data.application
			this.dialogForm.domain = data.domain
			this.dialogForm.download_url = data.download_url
			this.dialogForm.expired_at = data.expired_at
			this.dialogForm.logo = data.logo
      this.EditId = data.id
			this.dialogControl.visible = true
		},

		// 上传图片
		async uploadImg() {
			try {
				this.dialogControl.uploading = true
				const file = await uploadFileEvent({ accept: 'image/jpeg, image/png' })
        if (file.size / 1024 / 1024 > 2) {
          this.$message.error('图片大小不能超过2M')
          return
        }
        const { uri } = await httpRequest(file, this.$api3.question_set.upload)
				this.dialogForm.logo = uri
				this.dialogControl.uploading = false
			} catch (e) {
				this.dialogControl.uploading = false
			}
		},

		// 创建代理配置
		confirm: debounce(async function () {
			await this.$refs['newForm'].validate()
			const data = { ...this.dialogForm }
			this.dialogControl.submitting = true
			if (this.dialogControl.action == 'create') {
				await this.$api.agency_system.create(data)
				this.dialogControl.visible = false
				this.queryPageListData('refresh')
			}

			if (this.dialogControl.action == 'update') {
				await this.$api.agency_system.update(this.EditId, {
          ...data,
          region_code: last(data.region_code)
        })
				this.dialogControl.visible = false
				this.queryPageListData('refresh')
			}
		}, 200),

		//每页下拉只显示的数据
		handleSizeChange(val) {
			console.log('val', val)
			this.listControl.pageSize = val
			this.queryPageListData()
		},

		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.listControl.currentPage = currentPage
			this.queryPageListData()
		},

		// 重置搜索
		clearList() {
			this.filterQuery.title = ''
			this.queryPageListData()
		},

		//批量删除数据
		async batchDelete() {
			let confirm = await this.$confirm('此操作将删除基础设置, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			const ids = this.multipleSelection.map(item => item.id)
			this.$api.agency_system.batchDelete(ids).then(cRes => {
				if (cRes.success === true) {
					this.queryPageListData()
				}
			})
		},

		// 删除数据
		async promptRemove(id) {
			let confirm = await this.$confirm('此操作将删除基础设置, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			await this.$api.agency_system.delete(id)
			// 刷新
			this.queryPageListData()
		},

		// 单个状态修改
		async resetState(id, state) {
			let confirm = await this.$confirm('此操作将修改用户状态, 是否继续?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(_ => true)
				.catch(_ => false)

			if (!confirm) return

			await this.$api.agency_system.resetState(id, state)
			this.queryPageListData()
		},

		// 下载文件
		async download(data) {
			// 标签跨域下载
			const url = data.logo
			const xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status != 200) {
					alert('下载异常！')
					return
				}

				const newUrl = window.URL.createObjectURL(xhr.response)
				const a = document.createElement('a')
				a.setAttribute('href', newUrl)
				a.setAttribute('target', '_blank')
				a.setAttribute('download', data.title)
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
			}
			xhr.send()
		}
	}
}
</script>
<style lang="scss" scoped>
.arere {
	/deep/ .el-cascader .el-input .el-input__inner::placeholder {
		color: #323232;
	}
}

.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}

.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}

.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.addr {
	font-size: 14px;
	color: #b4b4b4;
}

.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}

.schoolNianji {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
}

.schollAxie {
	height: 35px;
	display: flex;
	-webkit-box-pack: justify;
	justify-content: space-between;
	vertical-align: middle;
	-webkit-box-align: center;
	align-items: center;
}

.schollApex {
	width: 32px;
	height: 28px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	line-height: 28px;
	-webkit-background-clip: text;
	display: flex;
}

.el-form-item {
	margin-bottom: 1px;
}

.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}

.pagination .el-pagination__total {
	float: left;
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	-webkit-background-clip: text;
}

.pagination .el-pagination__jump {
	margin-left: 9px;
	font-weight: normal;
	color: #666666;
}

.ClassesRadio {
	margin-right: 32px;
	padding-bottom: 15px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}

.ClassChekbox {
	margin-right: 8px;
	width: 90px;
	height: 32px;
	padding-bottom: 0px;
	font-size: 16px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #323232;
	-webkit-background-clip: text;
}

.avatar-uploader {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	width: fit-content;
	background: #f2f2f2;
}

.avatar-uploader:hover {
	border-color: #409eff;
}

.avatar-uploader-icon {
	font-size: 50px;
	color: #8c939d;
	width: 128px;
	height: 128px;
	line-height: 128px;
	text-align: center;
}

.avatar-uploader .avatar {
	width: 128px;
	height: 128px;
	display: block;
}
</style>
